import type { HTMLAttributes, JSX } from "react";

import type { IntentName } from "@/design";
import { cn } from "@/shared/lib/cn";

const INTENT_CLASS: Record<IntentName, string> = {
  success: "bg-[var(--intent-success-bg)] text-[var(--intent-success-fg)]",
  warning: "bg-[var(--intent-warning-bg)] text-[var(--intent-warning-fg)]",
  danger: "bg-[var(--intent-danger-bg)] text-[var(--intent-danger-fg)]",
  info: "bg-[var(--intent-info-bg)] text-[var(--intent-info-fg)]",
  neutral: "bg-[var(--intent-neutral-bg)] text-[var(--intent-neutral-fg)]",
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  intent?: IntentName;
  dot?: boolean;
}

export function Badge({
  intent = "neutral",
  dot = false,
  className,
  children,
  ...props
}: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold shadow-[var(--sh-xs)]",
        INTENT_CLASS[intent],
        className,
      )}
      {...props}
    >
      {dot && (
        <span
          aria-hidden
          className="h-1.5 w-1.5 shrink-0 rounded-full bg-current"
          style={{ boxShadow: "0 0 0 3px color-mix(in srgb, currentColor 18%, transparent)" }}
        />
      )}
      {children}
    </span>
  );
}
